module.exports = __webpack_public_path__ + "static/media/error.080c8183.svg";